import { Component } from '@angular/core';
import { UserDetailsService } from '../services/user-details.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiServicesService } from '../services/api-services.service';
import { SnackbarService } from '../services/snackbar.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-upload-post',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatProgressSpinnerModule],
  templateUrl: './upload-post.component.html',
  styleUrl: './upload-post.component.css'
})
export class UploadPostComponent {

  profilePic: any;
  userData: any;
  userName: any;
  postForm!: FormGroup;
  userId: any;


  constructor(
    private userdetails: UserDetailsService,
    private fb: FormBuilder,
    private api: ApiServicesService,
    private snackbarService: SnackbarService
  ) { }


  ngOnInit() {
    this.userdetails.userdetails$.subscribe((userData) => {
      this.userData = userData;
      if (userData && userData.user) {
        this.profilePic = userData.thumbnail_image || '';
        this.userName = this.userData.user.first_name;
        this.userId = this.userData.user._id;
      }
    });

    this.postForm = this.fb.group({
      postContent: ['', [Validators.required, Validators.maxLength(200)]],
    });
  }

  showLoader: boolean = false;
  onSubmit(): void {
    if (this.postForm.invalid) {
      this.postForm.markAllAsTouched();
      return;
    }
    this.showLoader = true
    this.api.CreatePost(this.postForm?.get('postContent')?.value).subscribe({
      next: (responce) => {
        this.showLoader = false;
        this.postForm.reset();
        this.userdetails.getAllPost(this.userId, 1, 10);
        this.snackbarService.openCustomSnackbar(
          {
            icon: true,
            message: 'Post Uploaded Successfully',
            className: 'success',
          }
        );
      },
      error: (err) => {
        this.showLoader = false;
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      },
    });
  }
}
